import { ModuleLanding, ModuleOffers, Faq, SectionHead } from '../../shared/components/Common';
import Icon from '../../shared/components/Icons';
import { img } from '../../shared/data/common';

const plans = [
  ['flights', 'Single trip', 'Cover for one trip abroad, from a few days up to 180 days.'],
  ['file', 'Student', 'Long-stay cover for studying abroad — 6 months to 3 years, ages 18 to 45.'],
  ['calendar', 'Annual multi-trip', 'Unlimited trips for a year, each up to 30, 45, 60 or 90 days.'],
];

const benefits = [
  ['hospital', 'Medical emergencies', 'Emergency hospitalisation and evacuation abroad'],
  ['close', 'Trip cancellation & delay', 'Get back non-refundable costs when plans go wrong'],
  ['bag', 'Baggage loss & delay', 'Compensation and tracking for lost or delayed bags'],
  ['file', 'Passport loss', 'Help and cover for emergency travel documents'],
  ['lock', 'Theft & cyber cover', 'Mugging cover and digital-risk assistance on select plans'],
  ['headset', '24x7 assistance', 'Global helpline wherever you travel'],
];

const steps = [
  ['Inform', 'Call our 24x7 helpline or email claims within 7 days of the incident.'],
  ['Submit', 'Upload documents — bills, reports, FIR or airline letters — online.'],
  ['Settle', 'Most claims are settled within 7 working days directly to your bank.'],
];

const faqs = [
  ['Is travel insurance mandatory?', 'It is mandatory for Schengen visas and strongly recommended everywhere else, especially for medical emergencies abroad.'],
  ['Can I buy insurance after my trip has started?', 'No. The policy must be purchased before departure from India.'],
  ['Are pre-existing diseases covered?', 'Pre-existing conditions are excluded unless the emergency is life-threatening. Please read the policy wording.'],
  ['Who can be insured?', 'Travellers up to 70 years old can buy online; student cover is for ages 18 to 45. Up to 10 travellers per policy.'],
  ['Why do you ask for each traveller’s age?', 'Premiums depend on age. At checkout the date of birth must match the age you searched with.'],
  ['Can I cancel my policy?', 'Yes — online from My Trips up to 24 hours before cover starts, for one traveller or everyone. The premium is refunded; the convenience fee is not.'],
];

export default function InsuranceSearch() {
  return (
    <ModuleLanding tab="insurance" title="Travel insurance" subtitle="Single-trip, student and annual multi-trip cover · Instant policy by email · 24x7 global assistance" image={img('1488646953014-85cb44e25828', 1800)}>
      <section className="section container">
        <SectionHead title="Cover for every kind of trip" />
        <div className="perk-row three">
          {plans.map(([ic, t, d]) => (
            <div key={t} className="perk"><span className="perk-icon"><Icon name={ic} size={22} /></span><div><b>{t}</b><span className="muted small">{d}</span></div></div>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="What's covered" />
        <div className="perk-row three">
          {benefits.map(([ic, t, d]) => (
            <div key={t} className="perk"><span className="perk-icon"><Icon name={ic} size={22} /></span><div><b>{t}</b><span className="muted small">{d}</span></div></div>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Hassle-free claims in 3 steps" />
        <ol className="claim-steps">
          {steps.map(([t, d], i) => <li key={t}><span className="day-badge">{i + 1}</span><div><b>{t}</b><span className="muted small">{d}</span></div></li>)}
        </ol>
      </section>

      <section className="section container">
        <SectionHead title="Insurance offers" />
        <ModuleOffers module="insurance" />
      </section>

      <section className="section container">
        <SectionHead title="Frequently asked questions" />
        <Faq items={faqs} />
      </section>
    </ModuleLanding>
  );
}
